module.exports = __webpack_public_path__ + "static/media/Bernie_Rice.0665b591.png";